import axios from "axios";

const axios_ = axios.create({
  baseURL: process.env.REACT_APP_API_URL
});

export const setJwt = (jwt: string) => {
  // console.log(jwt);
  axios_.defaults.headers.common['Authorization'] = `Bearer ${jwt}`;
};

export const clearJwt = () => {
  // console.log(jwt);
  axios_.defaults.headers.common['Authorization'] = `Bearer null`;
};

export const getArticles = async (topic_id: number, page?: number) => {
  return await axios_.get(`/topics/${topic_id}/articles?p=${page}`);
};

export default axios_;
